module.exports = __webpack_public_path__ + "img/treppe.43c658d4.jpg";